module.exports = __webpack_public_path__ + "static/media/thorildsplan-liggande.d549aadc.jpeg";